<form class="form-group" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <div class="close-container">
    <mat-icon class="close-icon" (click)="closeDialog()"></mat-icon>
  </div>
  <div class="title title--lg dialog" mat-dialog-title>Add Faculty</div>
  <mat-dialog-content>
    <div class="smallerText">Please complete the following fields and click Save to create the new faculty.</div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div>
          <ul>
            <li *ngFor="let item of errors" class="required-text">{{item}}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="title">First Name</div>
        <input class="form-control" formControlName="{{firstNameControl}}" type="text" />
        <div class="required-text" *ngIf="invalidRequiredField(firstNameControl)">
          First Name is required
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="title">Last Name </div>
        <input class="form-control" formControlName="{{lastNameControl}}" type="text" />
        <div class="required-text" *ngIf="invalidRequiredField(lastNameControl)">
          Last Name is required
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="title">Email</div>
        <input class="form-control" formControlName="{{emailControl}}" type="text" />
        <div class="required-text"
          *ngIf="formGroup.controls[emailControl].hasError('email') && !formGroup.controls[emailControl].hasError('required')">
          Please enter a valid email address
        </div>
        <div class="required-text" *ngIf="invalidRequiredField(emailControl)">
          Email is required
        </div>
      </div>
      <div class="col-12 col-md-6"> <!-- *ngIf="!this.data.primaryEmailAddress" -->
        <div class="title"> Confirm Email </div>
        <input class="form-control" formControlName="{{confirmEmailControl}}" type="text" />
        <div class="required-text" *ngIf="invalidRequiredField(confirmEmailControl)">
          Confirm Email is required
        </div>
        <div class="required-text"
          *ngIf="formGroup.hasError('emailNotMatching') && !formGroup.controls[emailControl].hasError('required') && !formGroup.controls[confirmEmailControl].hasError('required')">
          Emails do not match
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="title"> Institutional Email </div>
        <input class="form-control" formControlName="{{institutionalEmailControl}}" type="text" />
      </div>
      <div class="col-12 col-md-6">
        <div class="title">Select the faculty member's role:</div>
        <mat-select class="small--font" placeholder="Select a Role" formControlName="{{roleCodeControl}}" disableRipple panelClass="mat-panel">
          <mat-option value="">Select a Role</mat-option>
          <mat-option *ngFor="let i of this.facultyRoleValues" [value]="i.facultyRoleCode">{{i.facultyRoleDescription}}</mat-option>
        </mat-select>
        <div class="required-text" *ngIf="invalidRequiredField(roleCodeControl)">
          Role is required
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions>
    <div class="btn--inline dialog-btn-container btn-align-right">
      <input type="button" class="btn btn--outline hide-on-mobile " (click)="closeDialog()" value="Cancel">
      <button class="btn btn--solid btn--red" type="submit" [disabled]="!canAddFaculty()">Save</button>
    </div>
  </div>
</form>
<aaos-spinner [isLoading]="loading"></aaos-spinner>
